// extracted by mini-css-extract-plugin
export default {"wrapper":"Settings_wrapper__fipQx","content":"Settings_content__Jf72X"};